<app-auth-header [title]="'Request Password'" [showMenu]="false"></app-auth-header>
<div class="auth-content">
  <ng-template [ngIf]="!resetRequestSubmitted" [ngIfElse]="submissionResponse">
    <form (ngSubmit)="submitRequest()" [formGroup]="resetForm" class="auth-form">
      <div class="subtext centered-with-padding">
        Please enter the email address associated with your account
      </div>
      <div class="standard-error-message" *ngIf="formErrMsg">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="error-text">{{formErrMsg}}</span>
      </div>
      <label>Email Address</label>
      <div class="input-error-wrap last-one">
        <input class="block" type="text" name="email" formControlName="email">
        <app-error-msg
          [control]="resetForm.controls['email']"
          [show]="resetForm.controls['email'].touched && resetForm.controls['email'].invalid">
        </app-error-msg>
      </div>
      <button class="block btn auth-btn" type="submit">Request Password</button>
      <a class="pull-left auth-link" routerLink="/login">Log In</a>
      <a class="pull-right auth-link" href="mailto:eProve@advanc-ed.org?subject=eProve%20strategies%20question">Contact us for login help</a>
    </form>
  </ng-template>
  <ng-template #submissionResponse>
    <div class="subtext centered-with-padding">
      <p>If a user account exists for the email address provided, a reset password link has been emailed to you.</p>
      <p>Didn't receive an email?</p>
      <p>
        Be sure to check junk/spam folders or
        <a class="auth-link blue-link" href="mailto:eProve@advanc-ed.org?subject=eProve%20strategies%20question">
          Contact us for login help.
        </a>
      </p>
    </div>
  </ng-template>
</div>

